<template>
  <div id="app">
    <el-container>
      <el-header height="40px">
        <div style="height: 40px;width: 100%;">
          <div class="headerBox">
            <div class="logo cursor">
              <img :src="config.logoUrl" alt="">
            </div>
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" text-color="#152646" active-text-color="#0D68FF">
              <el-menu-item index="/" >
                <router-link to="/">首页</router-link>
              </el-menu-item>
              <el-menu-item index="/scheme" v-for="(item,index) in typeList" :key="index" disabled>
                <el-popover
                  placement="top-start"
                  trigger="hover">
                  <router-link slot="reference" to="">{{ item.name }}</router-link>
                  <div class="xuanxiangBox">
                    <div class="list cursor" v-for="(e,i) in item.child" :key="i" 
                    @click="goList(e,i,item.category_id,1)" >
                      <img v-if="e.image" :src="e.image.file_path" alt="">
                      <p>{{e.name}}</p>
                    </div>
                  </div>
                </el-popover>
              </el-menu-item>
              <!-- <el-menu-item index="/scheme" v-if="typeList.length>=1" disabled>
                <el-popover
                  placement="top-start"
                  trigger="hover">
                  <router-link slot="reference" to="">{{ typeList[0].name }}</router-link>
                  <div class="xuanxiangBox">
                    <div class="list cursor" v-for="(item,index) in typeList[0].child" :key="index" 
                    @click="goList(item,index,typeList[0].category_id,1)" >
                      <img v-if="item.image" :src="item.image.file_path" alt="">
                      <p>{{item.name}}</p>
                    </div>
                  </div>
                </el-popover>
              </el-menu-item>
              <el-menu-item index="/report" v-if="typeList.length>=2">
                <el-popover
                  placement="top-start"
                  trigger="hover">
                  <router-link slot="reference" to="/report">{{ typeList[1].name }}</router-link>
                  <div class="xuanxiangBox">
                    <div class="list cursor" v-for="(item,index) in typeList[1].child" :key="index" 
                    @click="goList(item,index,typeList[1].category_id,2)">
                      <img v-if="item.image" :src="item.image.file_path" alt="">
                      <p>{{item.name}}</p>
                    </div>
                  </div>
                </el-popover>
              </el-menu-item>
              <el-menu-item index="/report" v-if="typeList.length>=3">
                <el-popover
                  placement="top-start"
                  trigger="hover">
                  <router-link slot="reference" to="/report">{{ typeList[2].name }}</router-link>
                  <div class="xuanxiangBox">
                    <div class="list cursor" v-for="(item,index) in typeList[2].child" :key="index" 
                    @click="goList(item,index,typeList[2].category_id,2)">
                      <img v-if="item.image" :src="item.image.file_path" alt="">
                      <p>{{item.name}}</p>
                    </div>
                  </div>
                </el-popover>
              </el-menu-item> -->
              <el-menu-item index="/collection">
                <router-link to="/collection">合集</router-link>
              </el-menu-item>
              <!-- <el-menu-item index="/othor" v-if="typeList.length>=3">
                <router-link to="/othor">{{ typeList[2].name }}</router-link>
              </el-menu-item> -->
            </el-menu>
            <div class="othorBox">
              <div class="vipBox cursor" @click="goVip">
                <img class="icon" src="../src/assets/icon/vip.png" alt="">
                <p>加入会员</p>
              </div>
              <div class="upload cursor" @click="goPromotion">
                <img class="icon2" src="../src/assets/icon/red.png" alt=""></img>
                <p>分享有赏</p>
              </div>
              <div class="upload cursor" @click="goUpload">
                <img class="icon" src="../src/assets/icon/money.png" alt=""></img>
                <p>上传方案</p>
              </div>
              <div v-if="loginSta" class="userSet">
                <el-popover
                  placement="bottom"
                  title=""
                  width="115px"
                  trigger="hover"
                  content="">
                  <div class="userBox cursor" slot="reference" @click="$router.push('/user')">
                    <img :src="userInfo.avatarUrl" alt="" class="headImg">
                    <img v-if="userInfo.level == 6" src="../src/assets/vip/12.png" alt="" class="vip">
                    <img v-if="userInfo.level == 7" src="../src/assets/vip/22.png" alt="" class="vip">
                    <img v-if="userInfo.level == 8" src="../src/assets/vip/32.png" alt="" class="vip">
                    <!-- <p>{{userInfo.nickName}}</p> -->
                  </div>
                  <div class="userList">
                    <div @click="$router.push('/user')" class="list cursor">我的主页</div>
                    <div @click="$router.push('/member')" class="list cursor">会员中心</div>
                    <div @click="$router.push('/creation')" class="list cursor">创作收益</div>
                    <div @click="$router.push('/promotion')" class="list cursor">推广收益</div>
                    <div @click="$router.push('/wallet')" class="list cursor">我的钱包</div>
                    <div @click="goOut" class="list cursor">退出登录</div>
                  </div>
                </el-popover>
              </div>
              <div v-if="!loginSta" class="loginBtn cursor" @click="openLogin">登录/注册</div>
            </div>
          </div>
        </div>
      </el-header>
      <el-main>
        <!-- advertisement -->
        <img v-if="bannerShow" class="guanggao cursor" :src="bannerImage" alt="" @click="goAdvertisement">
        <keep-alive :exclude="['info','scheme','college_detail','userHome','colInfo']">
          <router-view></router-view>
        </keep-alive>
      </el-main>
      <el-footer height="160px"  v-if="footShow">
        <div class="footBox" >
          <div class="logo cursor">
            <img :src="config.logoUrl" alt="">
          </div>
          <el-menu :default-active="activefootIndex" class="el-menu-demo" mode="horizontal" @select="handlefootSelect" text-color="#152646" active-text-color="#0D68FF">
            <el-menu-item index="1" >
              <router-link to="/evaluate">真实评价</router-link>
            </el-menu-item>
            <el-menu-item index="2">
              <router-link to="/about">关于我们</router-link>
            </el-menu-item>
            <el-menu-item index="3">
              <router-link to="/copyright">版权声明</router-link>
            </el-menu-item>
            <el-menu-item index="4">
              <router-link to="/agreement">用户协议</router-link>
            </el-menu-item>
            <el-menu-item index="5">
              <router-link to="/problem">常见问题</router-link>
            </el-menu-item>
            <el-menu-item index="6">
              <router-link to="/mobileterminal">移动端</router-link>
            </el-menu-item>
          </el-menu>
          <div class="kefuCode">
            <div class="pic">
              <img :src="config.kefuUrl" alt="">
            </div>
            <p>客服二维码</p>
          </div>
        </div>
      </el-footer>
      <div class="icpBox">
        <a href="https://beian.miit.gov.cn" target="_blank">{{copyrightText}}</a>
      </div>
    </el-container>
    <!-- :before-close="handleClose" -->
    <el-dialog :visible.sync="loginState" :show-close="false" :lock-scroll="false" @close="popClose">
      <div class="loginBox">
        <div class="loginCon" v-if="loginType == 1">
          <div class="typeBox cursor">
            <div class="text">
              <img src="../src/assets/icon/shu.png" alt="">
            </div>
            <div class="lable" @click="loginType = 2">
              <img src="../src/assets/icon/phone.png" alt="">
            </div>
          </div>
          <div class="typeCon">
            <div class="title">扫码关注，快速登录</div>
            <div class="code">
              <img v-if="loginCode" :src="loginCode" alt="">
            </div>
            <div class="xieyi">
              <p>扫码即代表您已阅读并同意</p>
              <p style="color: #0D68FF;" class="cursor">
                <span @click="goAgreement(10015)">《用户协议》</span>
                <span style="color: #666666;">和</span>
                <span @click="goAgreement(10025)">《隐私协议》</span>
              </p>
            </div>
          </div>
        </div>
        <div class="loginCon" v-if="loginType == 2">
          <div class="typeBox cursor">
            <div class="text">
              <img src="../src/assets/icon/sao.png" alt="">
            </div>
            <div class="lable" @click="loginType = 1">
              <img src="../src/assets/icon/code.png" alt="">
            </div>
          </div>
          <div class="typeCon">
            <div class="title">手机登录</div>
            <div class="inputBox">
              <div class="list">
                <img src="../src/assets/icon/shou.png" alt="">
                <input type="number" v-model="phoneValue" placeholder="请输入手机号" maxlength="11" aria-placeholder="inp">
              </div>
              <div class="list">
                <img src="../src/assets/icon/anquan.png" alt="">
                <input type="text" v-model="codeValue" placeholder="请输入验证码" aria-placeholder="inp">
                <button class="codeGet cursor" @click="getCode">{{buttonText}}</button>
              </div>
            </div>
            <div class="agreeBox">
              <div class="agree cursor" @click="agreeSta = !agreeSta">
                <img v-if="agreeSta" src="../src/assets/icon/agree.png" alt="">
              </div>
              <p>我已阅读并同意
                <span style="color: #0D68FF;" class="cursor">
                  <span @click="goAgreement(10015)">《用户协议》</span>
                <span style="color: #666666;">和</span>
                  <span @click="goAgreement(10025)">《隐私协议》</span>
                </span>
              </p>
            </div>
            <button class="loginBtn cursor" @click="loginBtn">登录</button>
          </div>
        </div>
        <div class="close cursor" @click="closePop">
          <img src="../src/assets/icon/close.png" alt="">
        </div>
      </div>
    </el-dialog>
    <messageToast ref="toast" />
  </div>
</template>

<script>
import { bus } from './config/bus';
export default {
  name: 'App',
  data() {
    //这里存放数据
    return {
      width:'',
      activeIndex: '/',
      activefootIndex:'',
      bannerShow:false,
      footShow:false,
      topSta:false,
      loginType:1,
      agreeSta:false,
      phoneValue:'', // 手机号
      codeValue:'', // 验证码
      countdown: 60, // 倒计时秒数
      timer: null, // 计时器引用
      canSend: true, // 是否可以发送验证码
      loginSta:false,
      bannerImage:'',
      bannerUrl:'',
      config:{},
      loginCode:'',
      loginState:false,
      ticket:'',
      referee_id:'',
      loginTimer:null,
      copyrightText:''
    }
  },
  watch: {
    $route(to, from) {
      // 根据路由的meta字段来控制导航栏的显示和隐藏
      this.bannerShow = to.meta.bannerSta;
      this.footShow = to.meta.footSta;
      this.topSta = to.meta.topSta;
      this.activeIndex = to.path; // 监听路由变化，更新激活项
      // console.log(to.path,'====');
      // if(to.path == '/scheme'){
      //     this.activeIndex = '/scheme';
      // }else if(route.path == '/product/productDetial'){
      //     this.activeIndex = '/product/product';
      // }else{
      //     this.activeIndex = route.path; // 监听路由变化，更新激活项
      // }
    },
    loginPop(newVal, oldVal) {
      console.log(`someField changed from ${oldVal} to ${newVal}`);
      // 在这里执行你的逻辑
      if(newVal){
        this.$getRequest("user.user/getGzhLoginQr?app_id=10001").then((res) => {
          if(res.code == 1){
              this.ticket = res.data.ticket;
              this.loginCode = res.data.url;
              this.$forceUpdate();
              this.loginState = true;
              this.codeTicketverify();
          }
        });
      }else{
        this.loginState = false;
        this.loginTimer = null;
      }
    },
    loginType(newVal, oldVal) {
      console.log(`someField changed from ${oldVal} to ${newVal}`);
      // 在这里执行你的逻辑
      if(newVal == 1){
        this.$getRequest("user.user/getGzhLoginQr?app_id=10001").then((res) => {
          if(res.code == 1){
              this.ticket = res.data.ticket;
              this.loginCode = res.data.url;
              this.$forceUpdate();
              this.loginState = true;
              this.codeTicketverify();
          }
        });
      }
    }
  },
  computed: {
    buttonText() {
      return this.canSend ? '发送验证码' : `${this.countdown}秒后重试`;
    },
    loginPop() {
      return this.$store.state.loginPop;
    },
    typeList(){
      return this.$store.state.typeList;
    },
    pcLink(){
      return this.$store.state.pcLink;
    }
  },
  mounted(){
    this.activeuserIndex = this.$route.path;
    this.getBanner();
    this.getConfig();
    this.searchFactor();
    this.searchHistoryList();
    this.getIndex();
    this.getUserinfo();
    this.getQrcode();
    this.icpText();
    bus.$on('openPop',(data)=>{
      console.log(data)
      this.$refs.toast.show(data);
    })
  },
  methods: {
    openLogin(){
      this.$getRequest("user.user/getGzhLoginQr?app_id=10001").then((res) => {
        if(res.code == 1){
            this.ticket = res.data.ticket;
            this.loginCode = res.data.url;
            this.$forceUpdate();
            this.loginState = true;
            this.codeTicketverify();
        }
      });
    },
    closePop(){
      this.$store.state.loginPop = false;
      this.loginState = false;
    },
    // 登录
    loginBtn(){
      if(!this.phoneValue){
        this.$refs.toast.show('请输入手机号');
        return;
      }
      if(!this.codeValue){
        this.$refs.toast.show('请输入验证码');
        return;
      }
      if(!this.agreeSta){
        this.$refs.toast.show('请阅读并同意用户协议和隐私协议');
        return;
      }
      // 登录
      let data = {
        mobile: this.phoneValue,
        code: this.codeValue
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, .2)'
      });
      this.$postRequest("user.useropen/phonelogin",data).then((res) => {
        loading.close();
        if(res.code == 1){
            this.$store.state.loginPop = false;
            window.localStorage.setItem('token',res.data.token);
            window.localStorage.setItem('user_id',res.data.user_id);
            this.getUserinfo();
            this.$router.replace({ path: '/' })
            this.$postRequest("user.level/getMiniProgramQrcode").then((res) => {
              if(res.code == 1){
                this.$store.state.userQrcode = res.data;
              }
            });
        }
      });
    },
    // 关闭弹窗删除轮询
    popClose(){
      this.loginTimer = null;
    },
    // 轮询请求是否扫码登录
    codeTicketverify(){
      this.loginTimer = setTimeout(()=>{
        this.$postRequest("user.user/ticketverify",{
          ticket:this.ticket
        }).then((res) => {
          if(res.code == 1){
            // console.log('======11轮询扫码')
            if(res.data.status == 0){
              // console.log('======22没有登录',this.loginState,this.loginType)
              if(this.loginState && this.loginType == 1){
                // console.log('======33是否是扫码状态')
                if(this.loginTimer){
                  // console.log('======44定时器是否还在')
                  this.codeTicketverify();
                }
              }
            }else if(res.data.status == 1){
              // is_add = 0 非新号， 1= 新号
              let query = this.$route.query;
              this.referee_id = query.referee_id;
              if(this.referee_id){
                console.log(this.referee_id,'you')
                if(res.data.is_add == 1){
                  this.$postRequest("user.user/bindReferee",{
                    referee_id:this.referee_id
                  }).then((resBang) => {
                    if(resBang.code == 1){
                        
                    }
                  });
                }
              }else{
                console.log(this.referee_id,'meiyou')
              }
              this.$store.state.loginPop = false;
              window.localStorage.setItem('token',res.data.token);
              window.localStorage.setItem('user_id',res.data.user_id);
              this.getUserinfo();
              this.$postRequest("user.level/getMiniProgramQrcode").then((res) => {
                if(res.code == 1){
                  this.$store.state.userQrcode = res.data;
                }
              });
              window.location.reload();
            }else{
              this.$refs.toast.show(res.msg);
            }
          }
        });
      },1000)
    },
    // 跳转广告
    goAdvertisement(){
      // this.$router.replace({ path: '/advertisement' })
      window.open(this.bannerUrl, '_blank');
    },
    // 根据二级跳转界面
    goList(item,index,num,type){
      // console.log('--选择',`/scheme?type=${num}&ertype=${item.category_id}`)
      // if(type == 1){
      //   this.$router.push(`/scheme?type=${num}&ertype=${item.category_id}`)
      // }else if(type == 2){
      //   this.$router.push(`/report?type=${num}&ertype=${item.category_id}`)
      // }
      this.$router.push(`/scheme?type=${num}&ertype=${item.category_id}`)
    },
    // 获取用户信息
    getUserinfo(){
      let data = {
        source:'h5'
      }
      this.$postRequest("user.index/center",data).then((res) => {
        if(res.code == 1){
          if(res.data.userInfo){
            this.loginSta = true;
            this.userInfo = res.data.userInfo;
            window.localStorage.setItem('userInfo',JSON.stringify(res.data.userInfo));
          }else{
            this.loginSta = false;
            this.$store.state.loginPop = true;
          }
        }
      });
    },
    // 获取小程序码
    getQrcode(){
      this.$postRequest("user.level/getMiniProgramQrcode").then((res) => {
        if(res.code == 1){
          this.$store.state.userQrcode = res.data;
        }
      });
    },
    // 获取搜索条件
    searchFactor(){
      this.$postRequest("index/searchFactor").then((res) => {
        if(res.code == 1){
          this.$store.state.sortList = res.data.default.sort;
          this.$store.state.timeList = res.data.default.time_options;
          this.$store.state.searchList = res.data.search;
        }
      });   
    },
    // 获取热门搜索
    searchHistoryList(){
      this.$postRequest("course.course/searchHistoryList").then((res) => {
        if(res.code == 1){
          this.$store.state.searchList = res.data.list;
        }
      }); 
    },
    // 获取分类
    getIndex(){
      this.$postRequest("course.category/index").then((res) => {
        if(res.code == 1){
          this.$store.state.typeList = res.data.list;
        }
      }); 
    },
    // 获取轮播图
    getBanner(){
      this.$getRequest("index/index?app_id=10001").then((res) => {
        if(res.code == 1){
          let ad = res.data.ad;
          this.bannerImage = ad.image.file_path;
          this.bannerUrl = ad.web_url
          window.localStorage.setItem('banner',JSON.stringify(ad))
        }
      }); 
    },
    // 获取页面配置信息
    getConfig(){
      this.$getRequest("index/getConfig?app_id=10001").then((res) => {
        if(res.code == 1){
          this.config = res.data.store;
          this.$store.state.config = res.data.store;
          this.$store.state.xuzhi = res.data.course;
          this.$store.state.withdraw = res.data.withdraw;
        }
      }); 
    },
    // 获取验证码
    getCode(){
      if(!this.phoneValue){
        this.$refs.toast.show('请输入手机号');
        return;
      }
      if (this.canSend) {
        // 这里可以添加发送验证码的逻辑，例如调用API发送验证码等
        let data = {
          phone:this.phoneValue,
          type:1
        }
        this.$postRequest("user.sms/sendSms",data).then((res) => {
          if(res.code == 1){
            this.canSend = false; // 禁用按钮
            this.startCountdown(); // 开始倒计时
            this.$refs.toast.show('验证码发送成功');
          }
        });
      }
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1; // 减少秒数
        } else {
          this.resetCountdown(); // 重置倒计时和状态
        }
      }, 1000); // 每1000毫秒减少一次，即每秒减少一次
    },
    resetCountdown() {
      clearInterval(this.timer); // 清除计时器
      this.countdown = 60; // 重置秒数
      this.canSend = true; // 重新启用按钮
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handlefootSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 跳转到upload
    goUpload(){
      if(window.localStorage.getItem("token")){
        this.$router.push('/upload');
      }else{
        this.loginState = true;
      }
    },
    // 跳转到推广页面
    goPromotion(){
      this.$router.push('/promotion');
    },
    // 跳转到会员
    goVip(){
      this.$router.push('/vip');
    },
    // 跳转到协议
    goAgreement(type){
      this.$store.state.loginPop = false;
      window.open(`${this.pcLink}agreementAll?type=${type}`, '_blank');
    },
    // 退出登录
    goOut(){
      window.localStorage.clear();
      this.$router.push('/');
      window.location.reload();
    },
    icpText(){
      const startYear = 2025; // 固定起始年
      const endYear = new Date().getFullYear(); // 自动获取当前年份（如2026）
      const icpCode = "豫ICP备2023036679号-5";
      this.copyrightText = `Copyright © ${startYear}-${endYear} ${icpCode}`;
    }
  },
  beforeDestroy() {
    this.loginTimer = null;
    clearInterval(this.timer); // 组件销毁前清除计时器，防止内存泄漏
  }
}
</script>

<style lang="less">
    @font-face {
      /*给字体命名*/
      font-family: 'ziti';
      /*引入字体文件*/
      src: url('./assets/PingFang Heavy.ttf');
    }
  *{
    margin: 0;
    padding: 0;
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
  }
  #app{
    font-family:ziti;
    min-width: 1800px;
    overflow-y: auto;
  }
  img {
    max-width: 100% !important;
    height: auto;
    display: block;
    object-fit:cover;
  }
  .el-header{
    width: 100%;
    padding: 0 !important;
    background: #FFFFFF;
  }
  .el-main{
    width: 100%;
    min-height: calc(100vh - 160px - 40px);
    padding: 0 !important;
  }
  .el-footer{
    width: 100%;
    padding: 0 !important;
    background: #FFFFFF !important;
  }
  .el-dialog{
    background: transparent !important;
    box-shadow: none !important;
  }
  .headerBox{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 40px;
    padding: 0 240px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    .logo{
      width: 120px;
      height: 30px;
      flex-shrink: 0;
      img{
        width: 120px;
        height: 30px;
      }
    }
    .el-menu.el-menu--horizontal{
      width: 700px;
      height: 40px !important;
      line-height: 40px !important;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom:none !important;
      padding: 0 !important;
      .el-menu-item{
        height: 40px !important;
        line-height: 40px !important;
        font-size: 18px !important;
        border-bottom:none !important;
      }
      .is-disabled{
        opacity: 1 !important;
      }
      a{
        display: block;
        height: 100%;
        height: 40px !important;
        line-height: 40px !important;
        font-size: 14px;
        color: #444444;
        &:hover{
          color: #0D68FF;
        }
      }
    }
    .othorBox{
      display: flex;
      align-items: center;
      .vipBox{
        width: 105px;
        height: 30px; 
        border-radius: 100px;
        background: linear-gradient(270deg, #E9C68C 0%, #FAEFDD 100%);
        color: #57380C;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        flex-shrink: 0;
        .icon{
          width: 21.72px;
          height: 20px;
          margin-right: 2px;
        }
      }
      .upload{
        width: 90px;
        height: 30px;
        border-radius: 5px;
        box-sizing: border-box;
        border: 1px solid #EBEBEB;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #1F2329;
        font-size: 12px;
        margin-right: 10px;
        flex-shrink: 0;
        .icon{
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
        .icon2{
          width: 12px;
          height: 15.3px;
          margin-right: 5px;
        }
      }
      .userBox{
        display: flex;
        align-items: center;
        flex-shrink: 0;
        position: relative;
        width: 30px;
        height: 30px;
        .headImg{
          width: 30px;
          height: 30px;
          margin-right: 10px;
          overflow: hidden;
          border-radius: 50%;
          flex-shrink: 0;
        }
        .vip{
          width: 8px;
          height: 8px;
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
      .loginBtn{
        width: 90px;
        height: 30px;
        border-radius: 5px;
        background: #FFFFFF;
        box-sizing: border-box;
        border: 1px solid #EBEBEB;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #1F2329;
        font-size: 12px;
        flex-shrink: 0;
      }
    }
  }
  .footBox{
    height: 100%;
    box-sizing: border-box;
    padding: 20px 240px 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    .logo{
      width: 120px;
      height: 48px;
      img{
        width: 120px;
        height: 48px;
      }
    }
    .el-menu.el-menu--horizontal{
      width: 700px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom:none !important;
      padding: 0 !important;
      background: transparent;
      .el-menu-item{
        font-size: 18px !important;
        border-bottom:none !important;
        background: transparent !important;
      }
      a{
        font-size: 14px;
        color: #444444;
        &:hover{
          color: #0D68FF;
        }
      }
    }
    .kefuCode{
      color: #606970;
      font-size: 12px;
      text-align: center;
      flex-shrink: 0;
      .pic{
        margin-bottom: 3px;
        img{
          width: 100px;
          height: 100px;
        }
      }
    }
  }
  .loginBox{
    display: flex;
    justify-content: center;
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      overflow: hidden;
      margin-left: 10px;
    }
    .loginCon{
      width: 460px;
      height: 500px;
      border-radius: 10px;
      background: #FFFFFF;
    }
    .typeBox{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .text{
        width: 81px;
        height: 30px;
        margin-right: 20px;
        img{
          width: 81px;
          height: 30px;
        }
      }
      .lable{
        width: 64.88px;
        height: 64px;
        img{
          width: 64.88px;
          height: 64px;
        }
      }
    }
    .typeCon{
      .title{
        font-size: 24px;
        color: #152646;
        margin-top: 19px;
        text-align: center;
      }
      .code{
        margin: 32px auto 0;
        width: 200px;
        height: 200px;
        border: 1px solid #0D68FF;
        img{
          width: 200px;
          height: 200px;
        }
      }
      .xieyi{
        margin-top: 55px;
        font-size: 16px;
        color: #666666;
        text-align: center;
        p{
          line-height: 1.2;
        }
      }
    }
    .inputBox{
      .list{
        width: 380px;
        height: 50px;
        padding: 7px 7px 7px 20px;
        margin: 30px auto 0;
        border-radius: 5px;
        background: #FFFFFF;
        box-sizing: border-box;
        border: 1px solid #CCCCCC;
        display: flex;
        align-items: center;
        img{
          width: 18px;
          height: 22px;
          flex-shrink: 0;
        }
        input{
          height: 100%;
          flex: 1;
          margin-left: 10px;
          font-size: 16px;
          color: #222222;
        }
        .inp{
          font-size: 16px;
          color: #AAAAAA;
        }
        .codeGet{
          width: 96px;
          height: 36px;
          border-radius: 5px;
          font-size: 14px;
          color: #FFFFFF;
          background: #0D68FF;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;
        }
      }
    }
    .agreeBox{
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666666;
      font-size: 16px;
      margin-top: 77px;
      .agree{
        width: 18px;
        height: 18px;
        border-radius: 5px;
        overflow: hidden;
        border: 1px solid #AAAAAA;
        margin-right: 10px;
      }
    }
    .loginBtn{
      width: 380px;
      height: 50px;
      border-radius: 10px;
      color: #FFFFFF;
      font-size: 16px;
      background: #0D68FF;
      margin: 20px auto 0;
      display: block;
    }
  }
  .xuanxiangBox::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  .xuanxiangBox{
    position: fixed;
    left: 50%;
    top: 40px;
    transform: translateX(-50%);
    width: 1440px;
    max-height: 400px;
    overflow: hidden;
    overflow-y: auto;
    padding: 40px 50px;
    box-sizing: border-box;
    background: #EEF4FD;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-wrap: wrap;
    .list{
      width: 240px;
      height: 130px;
      border-radius: 10px;
      background: #FFFFFF;
      color: #152646;
      font-size: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 28px;
      margin-bottom: 20px;
      &:nth-child(5n){
        margin-right: 0;
      }
      &:hover{
        color: #0D68FF;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.04);
      }
      img{
        width: 30px;
        height: 30px;
        margin-bottom: 10px;
      }
    }
  }
  .userList{
    width: 115px;
    height: 216px;
    padding: 0 12px;
    border-radius: 4px;
    background: #F0F0F0;
    box-sizing: border-box;
    border: 1px solid #F0F0F0;
    .list{
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 0.5px solid rgba(31, 35, 41, 0.05);
      color: #1F2329;
      font-size: 12px;
      &:nth-last-child(1){
        border: none;
      }
      &:hover{
        color: #0D68FF;
      }
    }
  }
  .el-popover{
    padding: 0 !important;
    min-width: 10px !important;
  }
  .icpBox{
    height: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    a{
      color: #999;
      &:hover{
        color: #0D68FF;
      }
    }
  }
</style>
